export default __webpack_public_path__ + "static/sustainability_3-326812862d6eeaad4dfd91354b7f0daa.jpeg";